module.exports = __webpack_public_path__ + "static/media/Icon metro-location.9d1ef2b5.svg";